<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col class="mb-1">
          <router-link :to="{ name: 'EXCMSlaList' }" class="btn btn-sm btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMSlaForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMSlaForm from './Form'
import Loader from '../../Layout/Loader'

const { mapGetters, mapActions } = createNamespacedHelpers('excmsla/create')

export default {
  components: {
    EXCMSlaForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }

      // this.$Swal({
      //   title: created.title + ' ' + this.$t('notifications.created'),
      //   type: 'success',
      //   showConfirmButton: false,
      //   timer: 1500
      // })
      this.$router.push({ name: 'EXCMSlaShow', params: { id: created['@id'] } })
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      let item = Object.assign({}, this.item)
      item.reactionTime = parseInt(item.reactionTime)
      item.bypassTime = parseInt(item.bypassTime)
      item.repairTime = parseInt(item.repairTime)
      this.create(item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
